import { render, staticRenderFns } from "./searchRes.vue?vue&type=template&id=1605ff2d"
import script from "./searchRes.vue?vue&type=script&lang=js"
export * from "./searchRes.vue?vue&type=script&lang=js"
import style0 from "./searchRes.vue?vue&type=style&index=0&id=1605ff2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports